module.exports = __webpack_public_path__ + "assets/img/translation-case-4.01466cfb.png";